import { render, staticRenderFns } from "./ListagemDocumentos.vue?vue&type=template&id=b4af320e&"
import script from "./ListagemDocumentos.vue?vue&type=script&lang=js&"
export * from "./ListagemDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ListagemDocumentos.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports